import { CopyContent, Text } from "@kanda-libs/ks-design-library";
import type { FunctionComponent } from "react";
import type { Address as AddressType } from "./types";

export interface AddressProps {
  address?: AddressType;
}

const Address: FunctionComponent<AddressProps> = function ({ address }) {
  return (
    <CopyContent
      className="text-left"
      content={Object.values(address || {})
        .filter(Boolean)
        .join(", ")}
    >
      <div className="flex flex-col">
        {address?.buildingName && (
          <Text
            text={address?.buildingName}
            className="text-14-22 text-neutral-700"
          />
        )}
        {address?.buildingNumber && (
          <Text
            text={address?.buildingNumber}
            className="text-14-22 text-neutral-700"
          />
        )}
        {address?.line1 && (
          <Text text={address?.line1} className="text-14-22 text-neutral-700" />
        )}
        {address?.line2 && (
          <Text text={address?.line2} className="text-14-22 text-neutral-700" />
        )}
        {address?.city && (
          <Text text={address?.city} className="text-14-22 text-neutral-700" />
        )}
        {address?.postcode && (
          <Text
            text={address?.postcode}
            className="text-14-22 text-neutral-700"
          />
        )}
      </div>
    </CopyContent>
  );
};

export default Address;
